import ArrowLeftIcon from "./arrowLeftIcon";
import CalendarIcon from "./calendarIcon";
import ChevronDownIcon from "./chevronDownIcon";
import ChevronRightIcon from "./chevronRightIcon";
import ChevronUpIcon from "./chevronUpIcon";
import ClockIcon from "./clockIcon";
import MinusIcon from "./minusIcon";
import TrophyIcon from "./trophyIcon";
import WalletIcon from "./walletIcon";
import BolaIcon from "./bolaIcon";
import PlusIcon from "./plusIcon";
import DoneCircle from "./doneCircle";
import UndoneCircle from "./undoneCircle";
import CloseWhite from "./closeWhite";
import DownloadWhite from "./downloadWhite";
import Share from "./share";
import ErrorImage from "./errorImage";

export default {
  arrowLeft: ArrowLeftIcon,
  calendar: CalendarIcon,
  chevronDown: ChevronDownIcon,
  chevronUp: ChevronUpIcon,
  chevronRight: ChevronRightIcon,
  clock: ClockIcon,
  minus: MinusIcon,
  trophy: TrophyIcon,
  wallet: WalletIcon,
  bola: BolaIcon,
  plus: PlusIcon,
  doneCircle: DoneCircle,
  undoneCircle: UndoneCircle,
  close: CloseWhite,
  download: DownloadWhite,
  share: Share,
  errorImage: ErrorImage,
};



// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/index.js